export const GATEWAY_MODELS = [
  "Milesight UG65",
  "Milesight UG67",
  "Seeed SenseCAP M2 Indoor (SX1302)",
  "Seeed SenseCAP M2 Indoor (SX1302-4G)",
  "Seeed SenseCAP M2 Outdoor",
  "Dragino LPS8v2-EC25",
] as const;

export type GatewayModel = (typeof GATEWAY_MODELS)[number];

export const GATEWAY_STATUSES = ["online", "offline", "never_seen"] as const;
export type GatewayStatus = (typeof GATEWAY_STATUSES)[number];

export const GATEWAY_STATUS_LABELS: Record<GatewayStatus, string> = {
  online: "Online",
  offline: "Offline",
  never_seen: "Never seen",
};

export const FREQUENCY_BANDS = ["EU868"] as const;
export type FrequencyBand = (typeof FREQUENCY_BANDS)[number];

export const GATEWAY_EUI_MAX_LENGTH = 16;

export type CreateGatewayRequest = {
  gateway_name: string;
  company_id?: number | null;
  portfolio_id?: number | null;
  gateway_model: string;
  frequency_band: string;
  gateway_eui: string;
};

export type UpdateGatewayRequest = {
  gateway_name: string;
  company_id?: number | null;
  portfolio_id?: number | null;
  frequency_band: string;
};

export type GatewayCompanyRef = {
  id: number;
  name: string;
};

export type GatewayPortfolioRef = {
  id: number;
  name: string;
};

export type GatewayItem = {
  id: number;
  name: string;
  gateway_eui: string;
  gateway_model: string;
  frequency_band: string;
  status: GatewayStatus;
  last_seen: string | null;
  company_id: number | null;
  company: GatewayCompanyRef | null;
  portfolio_id: number | null;
  portfolio: GatewayPortfolioRef | null;
};

export type DetectGatewayModelResponse = {
  gateway_model: string | null;
};

export type GatewayStatistics = {
  total: number;
  online: number;
  offline: number;
  never_seen: number;
};

export type RecognizeEuiResponse = {
  gateway_eui: string | null;
};

export const EUI_IMAGE_ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp"] as const;
export const EUI_IMAGE_MAX_SIZE = 5 * 1024 * 1024;
